<template>
  <div id="app"  class="go-top">
    <!-- pc端头部 -->
    <header class="hidden-xs-only pc-head" :class="{indexPage:isIndexPage, darkMode:darkMode}" >
      <div class="container" :class="language=='cn'?'tc':'tl'">
        <router-link to="/" class="logo"><img :src="darkMode && isIndexPage ? $t('nav.Logo_white') : $t('nav.Logo')"/></router-link>
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="true"
         >
          <el-menu-item v-for="(item,index) in $t('nav.navList')"  :key="index"  :index="item.url" @mouseover.native="isShowMenu=true" @mouseout.native="isShowMenu=false">
            {{item.name}}
          </el-menu-item>
        </el-menu>

        <el-dropdown  @command="changeType" placement="bottom-start">
          <span class="el-dropdown-link">
            {{ language=='cn' ? '中文' : language=='en'? 'ENGLISH' : 'РУССКИЙ' }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item :command="{ text:'中文', type:'cn' }">{{$t("nav.Language.cn")}}</el-dropdown-item>
            <el-dropdown-item :command="{ text:'ENGLISH', type:'en' }">{{$t("nav.Language.en")}}</el-dropdown-item>
            <el-dropdown-item :command="{ text:'РУССКИЙ', type:'ru' }">{{$t("nav.Language.ru")}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </header>

    <!-- 头部下拉菜单-->
    <div class="main-menu hidden-xs-only"  >
      <!-- <el-collapse-transition> -->
      <div v-show="isShowMenu" class="menu-box">
        <div @mouseover="isShowMenu=true" @mouseout="isShowMenu=false">
          <i class="el-icon-close" @click="closeMenu"></i>
          <div class="blogroll"  >
            <div class="container">  
              <el-row class="nav-row"> 
                <el-col v-for="(item,index) in $t('foot.footNav')"  :key="index">
                  <div class="list">
                    <h3 slot="title" @click="setNavIndex(item.title,item.title.url)">{{item.title.name}}</h3>
                    <ul>
                      <li v-for="(listItem,index) in item.list"  :key="index+'name'">
                        <span @click="setNavIndex(listItem,item.title.url)">
                          {{listItem.name}}
                        </span>
                      </li> 
                    </ul>
                  </div>
                </el-col>
              </el-row>

              <el-row  :gutter="30" class="pic-row"> 
                <el-col v-for="(item,index) in $t('home.banner.businessScope')"  :key="index">
                  <div class="pic" >
                      <img :src="item.pic" />
                      <div class="mark">
                        <i :style="`background: url(${item.icon}) no-repeat;`"></i>
                        <p>{{item.title}}</p>
                      </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="copyright">
          <div class="container">
            <div>
              <span v-html="$t('foot.Phone')"></span>
              <span v-html="$t('foot.tel')"></span>
              <span>{{$t("foot.RecruitTel")}}</span>
            </div>
            <div>
              <span>{{$t("foot.Address")}}</span>
            </div>
            <div>
              <span>Copyright 2025 ©大庆高新国际工贸集团 </span>
              <a href="https://beian.miit.gov.cn" target="_blank">黑ICP备2021006543号-1</a>
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044151"
                target="_blank"
              >
                <i class="police "></i>京公网安备 11010502044151号
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- </el-collapse-transition> -->
    </div>
    
    <!-- 移动端头部 -->
    <div class="mobile hidden-sm-and-up">
      <div class="mobile-head container">
        <router-link to="/" class="logo">
          <img :src="$t('nav.Logo')" />
        </router-link>
        <ul>
          <li>
            <el-dropdown  @command="changeType" placement="bottom-start">
              <span class="el-dropdown-link">
                {{ language=='cn' ? '中文' : language=='en'? 'ENGLISH' : 'РУССКИЙ' }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item :command="{ text:'中文', type:'cn' }">{{$t("nav.Language.cn")}}</el-dropdown-item>
                <el-dropdown-item :command="{ text:'ENGLISH', type:'en' }">{{$t("nav.Language.en")}}</el-dropdown-item>
                <el-dropdown-item :command="{ text:'РУССКИЙ', type:'ru' }">{{$t("nav.Language.ru")}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li>
            <i class="el-icon-menu" @click="drawer = true"></i>
          </li>
        </ul>
      </div>
    </div>

    <!-- 移动端导航菜单 -->
    <el-drawer :visible.sync="drawer" :with-header="false" size="80%" class="modile-drawer">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="vertical"
        @select="handleSelect"
        :router="true"
      >
        <el-menu-item :index="$t('nav.navList')[0].url" >
          <span slot="title">{{$t('nav.navList')[0].name}}</span>
        </el-menu-item>
        <label v-for="(item,index) in $t('foot.footNav')"  :key="index">
          <el-submenu :index="item.title.url">
            <template slot="title">
              <span :index="item.title.url"> {{item.title.name}}</span>
            </template>
            <el-menu-item :index="i.url" v-for="(i,index) in item.list"  :key="'my'+index" @click="setNavIndex(i,item.title.url)">
              {{i.name}}
            </el-menu-item>
          </el-submenu>
        </label>
      </el-menu>
    </el-drawer>

    <div class="main">
      <router-view />
    </div>

    <footer v-show="activeIndex != '/'" class="footer">
      <div class="contact-footer">
        <div class="container">
          <el-row>
            <el-col :span="18" :xs="24">
              <ul class="address">
                <li class="contact">
                  {{$t("contact.banner.bannerTitle")}}
                </li>
                <li>
                  <div><i class="el-icon-phone mr10"></i><span v-html="$t('foot.Phone')"></span></div>
                </li>
                <li>
                  <div>
                    <i class="el-icon-phone-outline mr10"></i>
                    <span v-html="$t('foot.tel')"></span>
                    <span class="recruit-item">{{$t("foot.RecruitTel")}}</span>
                  </div>
                </li>
                <li>
                  <div><i class="el-icon-location-outline mr10"></i>{{$t("foot.Address")}}</div>
                </li>
                <li>
                  <div>
                    <i class="el-icon-message mr10"></i>
                    <span v-html="$t('foot.Email')"></span>
                    <span class="recruit-item">{{$t("foot.RecruitEmail")}}</span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :span="6" :xs="24" class="pic-row">
              <div class="box">
                <img src="./assets/img/base/gzh.png" class="teg-img" />
                <p>{{$t("contact.wxName")}}</p>
              </div>
              <div class="box">
                <img src="./assets/img/base/douying.png" class="teg-img" />
                <p>{{$t("contact.dyName")}}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="copyright">
        <div class="container">
          <span>Copyright 2025 ©大庆高新国际工贸集团 </span>
          <span class="mr20">
            <a href="https://beian.miit.gov.cn" target="_blank">黑ICP备2021006543号-1</a>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044151"
              target="_blank"
            >
              <i class="police "></i>京公网安备 11010502044151号
            </a>
          </span>
          <span>*网站内所有统计数据均包含子公司</span>
        </div>
      </div>
    </footer>

    <!-- 侧边栏 hidden-xs-only-->
    <ul class="fixbar ">
      <li class="phone" @click="toContact">
        <div class="icon">
          <i class="el-icon-phone-outline"></i>
        </div>
      </li>
      <li @click="handleService">
        <div class="icon">
          <i class="el-icon-chat-dot-round"></i>
        </div>
      </li>
    </ul>
    <board-form ref="msgBoard" />
    <el-backtop target=".go-top" :right="20"></el-backtop>
  </div>
</template>

<script>
import boardForm from "./components/boardForm";
import dialogContact from "./components/dialog_contact";
import { mapGetters, mapActions } from "vuex"
export default {
  name: "App",
  data() {
    return {
      drawer: false,
      direction: "rtl",
      wechat:false,
      phone:false,
      isShowMenu: false,
      isIndexPage:false,
    };
  },
  components: {
    boardForm,
    dialogContact,
  },
  computed:{
    ...mapGetters([ 'language','darkMode' ]),
    activeIndex:{
      get:function(){ 
        return this.$store.getters.activeIndex 
      },
      set:function(val){
        sessionStorage.setItem("activeIndex",val);
        this.$store.commit('app/SET_ACTIVE',val);
      }
    },
  },
  watch: {
    $route(to,from) {
      document.getElementsByClassName("go-top")[0].scrollTop = 0; // 设置滚动条位置;
      if(to.path=='/'){
        this.isIndexPage=true;
        this.activeIndex="/";
        this.$store.commit('app/SET_DARKMODE',true);
      }else{
        this.isIndexPage=false;
        this.$store.commit('app/SET_DARKMODE',false);
      }
    }
  },
  methods: {
    handleService() {
      this.$refs.msgBoard.showBoard();
    },
    changeType(command) {
      console.log(command)
      this.$store.commit('app/SET_LANGUAGE',command.type);
      sessionStorage.setItem("lang", command.type );
      this.$i18n.locale = command.type;
      this.$router.go(0);
    },
    handleSelect(key,keyPath) { 
      this.activeIndex = key;
      this.isShowMenu=false;
      this.drawer = false;
    },
    setNavIndex(item,key){
      this.handleSelect(key);
      this.$router.push({
        path:item.url,
        query:item.param ? {part:item.param} : {},
      })

      if(key=="/about" || key== "/socialResponsibility"){
        const partId=this.$route.query.part;

        if(partId){
          this.$nextTick(()=>{
            document.querySelector("#"+partId).scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest",
            });
          })
        }
      }

      this.isShowMenu=false;
    },
    closeMenu(){
      this.isShowMenu=false;
    },
    toContact(){
      this.$router.push({path:'/contact'})
    },
  }
};
</script>
